angular.module('eCareVault.common.directives').directive('handleDestroy', function () {
    return {
        link: function (scope: IHandleDestroyScope, elm, attrs, ctrl) {
            //to handle the ondestroy event of fields inside composite objects and composite list
            //scope.form.key.length > 1 will confirm it is a field inside composite object or list                
            if (scope.form && scope.form.key.length > 1 && scope.item) {
                scope.$on('$destroy', function (event) {
                    let keyLen = scope.form.key.length;
                    let allow = (keyLen == 2);  //For composite objects
                    //For composite list need to skip the code if delete object was called
                    if (keyLen > 2) {
                        allow = !(scope.$parent.$parent.$parent.$parent['objDeleted'] || scope.item.editable); //When delete action is taken objDeleted flag is set to true; also skip if item is in editable mode
                    }
                    if (allow) {
                        /*Extracting the fldkey from keyStr. Some of the samples for keyStr are
                            1. subject[].studentId  --> text field inside composite list
                            2. subject[].goals[].objective  --> text field inside composite list inside composite list
                            3. subject[].guardian.guardianName  --> text field inside composite object inside composite list
                            scope.item refers to the item of composite list that this text field is part of.
                        */
                        let fldKey = scope.form.keyStr.split('[].').slice(-1)[0];
                        //If destroyStrategy is defined for the field then set the model accordingly
                        if (scope.form.destroyStrategy) {
                            switch (scope.form.destroyStrategy) {
                                case "null":
                                    _.set(scope.item, fldKey, null);
                                    break;
                                case "empty":
                                    _.set(scope.item, fldKey, "");
                                    break;
                                case "retain": // do nothing
                                    break;
                                case "remove":
                                    _.unset(scope.item, fldKey);
                                    break;
                            }
                        }
                        else { // if destroyStrategy is not defined then default is remove
                            _.unset(scope.item, fldKey);
                        }
                    }
                });
            }
        }
    };
});
interface IHandleDestroyScope extends ng.IScope {
    form: {
        key: any[];
        keyStr: string;
        destroyStrategy?: string;
    };
    item: any;
    objDeleted?: boolean;
}
